export default function initansprechpartner(){
    var resGrid = function () {
        $(".ansprechpartner-grid .ansprechpartner").css("height", "");
        var maxHeight = Math.max.apply(null, $(".ansprechpartner-grid .ansprechpartner").map(function () {
            return $(this).height();
        }).get());
        $(".ansprechpartner-grid .ansprechpartner").height(maxHeight);
    };

    resGrid();
    $(window).on("resize",function () {
        resGrid();
    });

    $(".ansprechpartner-toggle").on("click",function () {
        resGrid();
    });


    function scrollToAnsprechpartner(id) {
        if ($("a[name=" + id + "]").siblings(".mod-wrapper").height() === 0) {
            $("a[name=" + id + "]").siblings("header").children("h1").trigger("click");
        }
        $("body,html").animate({
            scrollTop: $("a[name=" + id + "]").offset().top - $(".stickheader:visible").height()
        }, 0);
        setTimeout(function () {
            $("body,html").animate({
                scrollTop: $("a[name=" + id + "]").offset().top - $(".stickheader:visible").height()
            }, 0);
        }, 50);
    }

    function triggerAnsprechpartnerSearch() {
        $.ajax({
            url: "nlid.html",
            method: "POST",
            data: {
                PLZ: $("input.ansprechpartner-suche").val()
            }
        }).done(function (res) {
            if (res.trim() !== "0") {

                //scrollToAnsprechpartner(res.trim());
                $(".niederlassungresult .result").text($("a[name=" + res.trim() + "]").data("niederlassungname"));
                $(".niederlassungresult").find("span.niederlassungsuche-error").hide();
                $(".niederlassungresult").find("span, i").not(".niederlassungsuche-error").show();
                $("input.ansprechpartner-suche").css("border", "").css("border-right", "0");
                $("button.btn-ansprechpartner-suche").css("border", "");
                $("a.niederlassungssuche-link").data("id", res.trim());
            } else {
                $(".niederlassungresult").find("span, i").not(".niederlassungsuche-error").hide();
                $(".niederlassungresult").find("span.niederlassungsuche-error").show();
                $("input.ansprechpartner-suche").css("border-top", "2px solid #C30000").css("border-left", "2px solid #C30000").css("border-bottom", "2px solid #C30000");
                $("button.btn-ansprechpartner-suche").css("border-top", "2px solid #C30000").css("border-right", "2px solid #C30000").css("border-bottom", "2px solid #C30000");
            }

        });
    }

    $("button.btn-ansprechpartner-suche").on("click", function () {
        triggerAnsprechpartnerSearch();
    });

    $("input.ansprechpartner-suche").on("keypress", function (e) {
        if (e.which == 13) {
            triggerAnsprechpartnerSearch();
        }
    });

    $(".niederlassungssuche-link").on("click", function (e) {
        e.preventDefault();
        scrollToAnsprechpartner($(this).data("id"));
    });

    function initStandorteAnsprechpartner(){
        if(!document.querySelector('.d2standorte')){
            return;
        }
        function handler(){
            this.classList.toggle('d2standorte__entry__head--active');
        }
        const entries = document.querySelectorAll('.d2standorte__entry__head');
        entries.forEach(entry => entry.addEventListener('click', handler));
    }
    initStandorteAnsprechpartner();
}